import { z } from 'zod';

export const registerSchema = z.object({
  first_name: z.string().nonempty("First name is required").max(255, "First name must not exceed 255 characters"),
  last_name: z.string().nonempty("Last name is required").max(255, "Last name must not exceed 255 characters"),
  email: z.string().email("Invalid email address").nonempty("Email is required"),
  telephone: z.string().nonempty("Telephone is required").max(20, "Telephone must not exceed 20 characters"),
  fax: z.string().max(20, "Fax must not exceed 20 characters").optional(),
  business_license_copy: z.union([
    z.instanceof(File).refine(file => file?.size <= 5000000, "Business license file must be 5MB or less"),
    z.string(),
    z.undefined()
  ]).optional(),
  federal_tax_id_copy: z.union([
    z.instanceof(File).refine(file => file?.size <= 5000000, "Federal tax ID file must be 5MB or less"),
    z.string(),
    z.undefined()
  ]).optional(),
  id_driver_license: z.union([
    z.instanceof(File).refine(file => file?.size <= 5000000, "Driving license file must be 5MB or less"),
    z.string(),
    z.undefined()
  ]).optional(),
  business_name: z.string().nonempty("Business name is required").max(255, "Business name must not exceed 255 characters"),
  address_1: z.string().nonempty("Address 1 is required").max(255, "Address 1 must not exceed 255 characters"),
  city: z.string().nonempty("City is required").max(255, "City must not exceed 255 characters"),
  post_code: z.string().nonempty("Post code is required").max(10, "Post code must not exceed 10 characters"),
  country: z.string().nonempty("Country is required").max(255, "Country must not exceed 255 characters"),
  region_state: z.string().nonempty("Region/State is required").max(50, "Region/State must not exceed 50 characters"),
  password: z.string().min(8, "Password must be at least 8 characters long").optional(),
  password_confirmation: z.string().min(8, "Password confirmation must be at least 8 characters long").optional(),
  subscribe_newsletter: z.boolean().default(false),
  remember: z.boolean().default(false),
}).refine((data) => {
  if (data.password || data.password_confirmation) {
    return data.password === data.password_confirmation;
  }
  return true;
}, {
  message: "Passwords don't match",
  path: ["password_confirmation"],
});